<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-top-transition"
    max-width="1200"
    persistent
  >
    <v-card>
      <v-toolbar color="blue" dark><h4>Datos de la Tarea</h4></v-toolbar>
      <v-card-text>
        <v-row class="mt-4">
          <v-col class="mb-5">
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="elemento.identificador"
                  label="Identificador"
                  type="number"
                  readonly
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="elemento.titular"
                  label="Titular"
                  readonly
                  type="text"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="elemento.vencimiento"
                  label="Vencimiento"
                  dense
                  type="text"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="elemento.barrio"
                  label="Barrio"
                  type="text"
                  readonly
                  dense
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="elemento.motivo"
                  label="Motivo"
                  type="text"
                  readonly
                  dense
                ></v-text-field>
              </v-col>

              <template v-if="tipoConsulta == 1">
                <v-col cols="6">
                  <v-text-field
                    v-model="elemento.nombreUsuario"
                    label="Usuario que realizo la inspeccion"
                    type="text"
                    readonly
                    dense
                  ></v-text-field>
                </v-col>
              </template>
              <template v-if="tipoConsulta != 1">
                <v-col cols="6">
                  <v-text-field
                    v-model="elemento.telefono"
                    label="Teléfono"
                    type="text"
                    readonly
                    dense
                  ></v-text-field>
                </v-col>
              </template>
            </v-row>
            <v-row dense>
              <v-col cols="3">
                <v-text-field
                  v-model="elemento.tension"
                  label="Tensión"
                  type="text"
                  dense
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  v-model="elemento.descripcionMotivo"
                  label="Descripcion Motivo"
                  dense
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  v-model="elemento.comentario"
                  label="Comentario"
                  type="text"
                  dense
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  v-model="elemento.detalle"
                  label="Detalle"
                  type="text"
                  dense
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="3">
                <v-text-field
                  v-model="elemento.distrito"
                  label="Distrito"
                  type="text"
                  readonly
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  v-model="elemento.domicilio"
                  label="Domicilio"
                  type="text"
                  dense
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  v-model="elemento.isn"
                  label="ISN"
                  type="text"
                  dense
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  v-model="elemento.mail"
                  label="Mail"
                  type="text"
                  dense
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3">
                <v-text-field
                  v-model="elemento.medidor"
                  label="Medidor"
                  type="text"
                  readonly
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  v-model="elemento.radio"
                  label="Radio"
                  type="text"
                  dense
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  v-model="elemento.recorrido"
                  label="Recorrido"
                  type="text"
                  dense
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  v-model="elemento.titular"
                  label="Titular"
                  type="text"
                  dense
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <template v-if="tipoConsulta == 1">
        <v-data-table
          :headers="headersMaterialesUtilizadosInspeccion"
          :items="tablaMaterialesUtilizadosInspeccion"
          :custom-filter="headersMaterialesUtilizadosInspeccion"
          class="elevation-1 mt-0"
          no-results-text="No se encontraron resultados"
          no-data-text="No ha cargado Ningun Dato"
          :footer-props="$store.state.traduccionTabla"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Lista de Materiales</v-toolbar-title>
            </v-toolbar>
          </template>
        </v-data-table>

        <v-data-table
          :headers="headersBobinasUtilizadasInspeccion"
          :items="tablaBobinasUtilizadasInspeccion"
          :custom-filter="headersBobinasUtilizadasInspeccion"
          class="elevation-1 mt-0"
          no-results-text="No se encontraron resultados"
          no-data-text="No ha cargado Ningun Dato"
          :footer-props="$store.state.traduccionTabla"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Lista de Bobinas</v-toolbar-title>
            </v-toolbar>
          </template>
        </v-data-table>
      </template>
      <v-card-actions class="justify-end">
        <v-btn title="Cerrar" color="red" dark @click="cerrarDialog()"
          ><v-icon>mdi-close-circle</v-icon>Cerrar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import moment from "moment";
export default {
  data() {
    return {
      tablaMaterialesUtilizadosInspeccion: [],
      tablaBobinasUtilizadasInspeccion: [],
      dialog: false, //ESTE MODAL
      elemento: {}, //OBJETO DE RECLAMO
      tipoConsulta: 0,
      headersMaterialesUtilizadosInspeccion: [
        { text: "Descripcion", value: "nombre", class: "black white--text" },
        {
          text: "Cantidad Original",
          value: "cantidad",
          class: "black white--text",
        },
        {
          text: "Cantidad Inspeccion",
          value: "cantidadActual",
          class: "black white--text",
        },
        { text: "Fecha", value: "fecha", class: "black white--text" },

        //{ text: "Motivo", value: "motivo" },
        //{ text: "Acciones", value: "actions", sortable: false },
      ],
      headersBobinasUtilizadasInspeccion: [
        // {
        //   text: "ID Bobina",
        //   value: "idBobinaUtilizada",
        //   class: "black white--text",
        // },
        {
          text: "Matricula Cable",
          value: "idMaterialCable",
          class: "black white--text",
        },
        {
          text: "ID Bobina Comercial",
          value: "idBobinaComercial",
          class: "black white--text",
        },
        {
          text: "ID Bobina Tarea",
          value: "idBobinaTarea",
          class: "black white--text",
        },
        {
          text: "Secuencia Inicio",
          value: "secInicio",
          class: "black white--text",
        },
        {
          text: "Secuencia Fin",
          value: "secFin",
          class: "black white--text",
        },
        {
          text: "Cantidad Utilizada",
          value: "cantidadUtilizada",
          class: "black white--text",
        },
        {
          text: "Cantidad Inspeccion",
          value: "cantidadInspeccion",
          class: "black white--text",
        },
        {
          text: "OT",
          value: "idOT",
          class: "black white--text",
        },
        //{ text: "Fecha", value: "fecha", class: "black white--text" },

        //{ text: "Motivo", value: "motivo" },
        //{ text: "Acciones", value: "actions", sortable: false },
      ],
    };
  },

  methods: {
    ...mapActions("reclamos", ["ObtenerDetalleReclamoPorId"]),
    //LIMPIA LOS CAMPOS
    async LimpiarCampos() {
      this.elemento.barrio = "";
      this.elemento.comentario = "";
      this.elemento.contratista = "";
      this.elemento.detalle = "";
      this.elemento.distrito = "";
      this.elemento.domicilio = "";
      this.elemento.identificador = "";
      this.elemento.indice = "";
      this.elemento.isn = "";
      this.elemento.mail = "";
      this.elemento.medidor = "";
      this.elemento.motivo = "";
      this.elemento.radio = "";
      this.elemento.recorrido = "";
      this.elemento.telefono = "";
      this.elemento.titular = false;
      this.elemento.vencimiento = false;
    },
    //ABRE EL MODAL

    cerrarDialog() {
      this.tipoConsulta = 0;
      this.dialog = false;
    },

    async AbrirModalInspeccionada(datos) {
      this.tipoConsulta = 1;
      await this.LimpiarCampos();
      console.log("Los datos son:");

      console.log(datos);

      (this.elemento.barrio = datos.barrio),
        (this.elemento.comentario = datos.comentario),
        (this.elemento.contratista = datos.contratista),
        (this.elemento.detalle = datos.detalle),
        (this.elemento.distrito = datos.distrito),
        (this.elemento.domicilio = datos.domicilio),
        (this.elemento.identificador = datos.identificador),
        (this.elemento.indice = datos.indice),
        (this.elemento.isn = datos.isn),
        (this.elemento.mail = datos.mail),
        (this.elemento.medidor = datos.medidor),
        (this.elemento.motivo = datos.motivo),
        (this.elemento.radio = datos.radio),
        (this.elemento.recorrido = datos.recorrido),
        (this.elemento.telefono = datos.telefono),
        (this.elemento.titular = datos.titular);
      this.elemento.vencimiento = datos.vencimiento;
      this.elemento.idTarea = datos.idTarea;
      this.elemento.nombreUsuario = datos.nombreUsuario;
      this.elemento.descripcionMotivo = datos.descripcionMotivo;

      console.log(this.elemento);

      var respuesta = "";

      this.url =
        this.$store.state.urlBase +
        "Material/recuperarMaterialesUtilizadosInspeccion?idTarea=" +
        this.elemento.idTarea;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de la tarea cancelada es:");

      this.tablaMaterialesUtilizadosInspeccion = respuesta;

      console.log(this.tablaMaterialesUtilizadosInspeccion);

      this.url =
        this.$store.state.urlBase +
        "Bobina/recuperarBobinasUtilizadasInspeccion?idTarea=" +
        this.elemento.idTarea;

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log(
        "El resultado de la respuesta de la bobina inspeccionada es:"
      );

      this.tablaBobinasUtilizadasInspeccion = respuesta;

      this.tablaMaterialesUtilizadosInspeccion = [
        ...new Map(
          this.tablaMaterialesUtilizadosInspeccion.map((item) => [
            item.idMaterial,
            item,
          ])
        ).values(),
      ];

      this.tablaBobinasUtilizadasInspeccion = [
        ...new Map(
          this.tablaBobinasUtilizadasInspeccion.map((item) => [
            item.idBobina,
            item,
          ])
        ).values(),
      ];
      this.dialog = true;
    },

    async AbrirModal(datos) {
      await this.LimpiarCampos();
      console.log("Los datos son:");

      console.log(datos);

      (this.elemento.barrio = datos.barrio),
        (this.elemento.comentario = datos.comentario),
        (this.elemento.contratista = datos.contratista),
        (this.elemento.detalle = datos.detalle),
        (this.elemento.distrito = datos.distrito),
        (this.elemento.domicilio = datos.domicilio),
        (this.elemento.identificador = datos.identificador),
        (this.elemento.indice = datos.indice),
        (this.elemento.isn = datos.isn),
        (this.elemento.mail = datos.mail),
        (this.elemento.medidor = datos.medidor),
        (this.elemento.motivo = datos.motivo),
        (this.elemento.radio = datos.radio),
        (this.elemento.recorrido = datos.recorrido),
        (this.elemento.telefono = datos.telefono),
        (this.elemento.titular = datos.titular);
      this.elemento.vencimiento = datos.vencimiento;
      this.elemento.descripcionMotivo = datos.descripcionMotivo;

      console.log(this.elemento);

      // this.elemento = this.$store.state.reclamos.reclamo;
      // console.log(this.elemento);
      // this.elemento.fechaTomado = moment(this.elemento.fechaTomado).format(
      //   "DD/MM/yyyy HH:mm"
      // );
      // if (this.elemento.peligro === "SI") {
      //   this.elemento.peligro = true;
      // } else {
      //   this.elemento.peligro = false;
      // }
      // if (this.elemento.artefactosQuemados === "SI") {
      //   this.elemento.artefactosQuemados = true;
      // } else {
      //   this.elemento.artefactosQuemados = false;
      // }
      // if (this.elemento.afectaVarios === "SI") {
      //   this.elemento.afectaVarios = true;
      // } else {
      //   this.elemento.afectaVarios = false;
      // }
      // if (this.elemento.vip === "SI") {
      //   this.elemento.vip = true;
      // } else {
      //   this.elemento.vip = false;
      // }
      // console.log(this.elemento);
      /*this.elemento.barrio =
        this.elemento.codigoBarrio + " - " + this.elemento.barrio;*/

      this.dialog = true;
    },
  },
};
</script>
